const APP_ENDPOINTS = {
	DASHBOARD: "/dashboard",
	SWAP: "/swap",
	SWAP_DONE: "/swap-done",
};
export default APP_ENDPOINTS;
